const assignments = {
  openTitle: "Offene Aufgaben ({{count}})",
  create: "Aufgabe erstellen",
  showAll: "Alle Aufgaben anzeigen",
  markCompleted: "Als erledigt markieren",
  markOpen: "Als offen markieren",
  assignmentsOverview: "Aufgabenübersicht ({{count}})",
  completedAssignment: "Erledigte Aufgaben ({{count}})",
  showCompleted: "Erledigte anzeigen",
  deleteAllCompletedAssignments: "Alle erledigten löschen",
  clientSelect: {
    searchHint: "Nach Name oder Geburtsdatum suchen",
    noResults: 'Keine Kund:innen für "{{query}}" gefunden.',
    bornOn: "geb.",
  },
  creationDialog: {
    title: "Neue Aufgabe erstellen",
    description: "Beschreibung",
    dueDate: "Fälligkeit",
    priority: "Priorität",
    caseNote: "Aktenvermerk",
    avAssignmentDefaultDescription: "Aktenvermerk",
    submitButton: "Aufgabe erstellen",
    successfullyAdded: "Aufgabe erfolgreich erstellt",
    priorityValues: {
      low: "Niedrig",
      normal: "Normal",
      high: "Hoch",
    },
  },
  editDialog: {
    title: "Aufgabendetails",
    successfullyUpdated: "Die Aufgabe wurde aktualisiert.",
    deleteButton: "Löschen",
    deleteConfirmTitle: "Aufgabe löschen",
    deleteConfirmText:
      "Möchten Sie diese Aufgabe wirklich dauerhaft löschen? Diese Aktion kann nicht mehr rückgängig gemacht werden.",
    deleteAllCompletedTitle: "Alle abgeschlossenen Aufgaben löschen",
    deleteAllCompletedConfirmText:
      "Sind Sie sicher, dass Sie alle abgeschlossenen Aufgaben endgültig löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    successfullyDeleted: "Die Aufgabe wurde gelöscht.",
    successfullyClosed: "Die Aufgabe wurde abgeschlossen.",
    successfullyReopened: "Die Aufgabe wurde erneut geöffnet.",
  },
};

export default assignments;
